import { useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import Navbar from "./components/Navabr";
import Footer from "./components/Footer";
import { AppContext } from "./context/AppContext";
import { FaPhone } from "react-icons/fa";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Route, Routes } from "react-router-dom";
import ExploreCourses from "./routes/Courses";
import Careers from "./routes/Careers";
import PolicyTabs from "./routes/TermsAndPolicy";
import Services from "./routes/Services";
import CallRequestModel from "./components/CallRequestModel";
import JobDetails from "./routes/Careers/JobDetails";
import NotFound from "./routes/NotFound";
// import DelayedFormPopup from "./components/DelayedFormPopup";
import AboutUs from "./routes/AboutUs";
// import Chatbot from "./components/ChatBot";

const App = () => {
  const { setModalShow } = useContext(AppContext);
  const location = useLocation();
  // Scroll to top whenever route (pathname) changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  function CallRequestButton() {
    return (
      <div
        className="call-request-button"
        title="Request a Call"
        onClick={() => {
          setModalShow(true);
        }}
      >
        <FaPhone />
        <span></span>
      </div>
    );
  }

  // function chatBotButton() {
  //   return (
  //     <div
  //       className="chatbot-button"
  //       title="Chatbot"
  //       onClick={() => {
  //         setChatbotShow(true);
  //       }}
  //     >
  //       {/* <RiRobot2Fill /> */}
  //       <img
  //         src="https://iqteche.in/static/media/wl_client_images/a7bb1e1b83bb44e0b00c3d46c9d29235.png"
  //         alt="IBIX Chatbot"
  //         className="chatbot-img"
  //       />
  //     </div>
  //   );
  // }

  const {
    activeSection,
    setActiveSection,
    coursesRef,
    successStoriesRef,
    setActiveRoute,
  } = useContext(AppContext);

  // Step 1: Setup scroll listener
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const buffer = 150;

      const isInSection = (ref) => {
        if (!ref?.current) return false;
        const top = ref.current.offsetTop;
        const height = ref.current.offsetHeight;
        return scrollY >= top - buffer && scrollY < top + height - buffer;
      };

      if (isInSection(coursesRef)) {
        setActiveSection("courses");
      } else if (isInSection(successStoriesRef)) {
        setActiveSection("success-stories");
      } else {
        setActiveSection("");
      }
    };

    // Step 2: Attach listener
    window.addEventListener("scroll", handleScroll);

    // Step 3: Trigger once on load (in case page loads mid-scroll)
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [coursesRef, successStoriesRef, setActiveSection]);

  // Step 4: Set activeRoute when path is "/"
  useEffect(() => {
    if (location.pathname === "/") {
      setActiveRoute("/");
    }
  }, [location.pathname, setActiveRoute]);

  return (
    <div className="App">
      <Navbar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      <div className="container-fluid p-0">
        <Routes>
          <Route path="/" Component={Home} />
          <Route path="/courses/fullstack" Component={ExploreCourses} />
          <Route path="/courses/specializations" Component={ExploreCourses} />
          <Route path="/courses/tech-tools" Component={ExploreCourses} />
          <Route path="/careers" Component={Careers} />
          <Route path="/terms-and-privacy" Component={PolicyTabs} />
          <Route path="/services" Component={Services} />
          <Route path="/about-us" Component={AboutUs} />
          <Route path="/careers/:role/:jobId" Component={JobDetails} />
          {/* Not found */}
          <Route path="/not-found" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
      </div>

      <Footer />

      {!(
        location.pathname.toLowerCase().startsWith("/careers") ||
        location.pathname.toLowerCase().startsWith("/services") ||
        location.pathname.toLowerCase().startsWith("/courses")
      ) && CallRequestButton()}

      {/* Chatbot button removed */}

      <CallRequestModel />
      {/* <DelayedFormPopup /> */}
      {/* Chatbot removed */}
      {/* {chatbotShow && <Chatbot />} */}
    </div>
  );
};

export default App;
